import { Alert, Box, Typography } from "@mui/material";

// ----------------------------------------------------------------------

type Props = {
	message: string;
	severity?: "info" | "warning";
};

export const MessageAlert = ({ message, severity = "info" }: Props) => {
	return (
		<Alert severity={severity} sx={{ mb: 1, mt: 1, maxWidth: { xs: 250, sm: 320 } }}>
			<Typography variant='body2'>{message}</Typography>
		</Alert>
	);
};

export default MessageAlert;
